import { ApolloClient, HttpLink, InMemoryCache, split } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { getMainDefinition } from '@apollo/client/utilities';
import { createClient } from 'graphql-ws';
import { getIdToken } from './auth';
import type { RuntimeConfig } from './config';

export function createApolloClient(cfg: RuntimeConfig) {
  const httpLink = new HttpLink({ uri: cfg.appSyncUrl });

  const authLink = setContext(async (_, { headers }) => {
    const token = await getIdToken();
    return { headers: { ...headers, ...(token ? { Authorization: token } : {}) } };
  });

  const wsUrl = cfg.appSyncUrl.replace('https://', 'wss://').replace('appsync-api', 'appsync-realtime-api');

  const wsLink = new GraphQLWsLink(
    createClient({
      url: wsUrl,
      connectionParams: async () => {
        const token = await getIdToken();
        return { Authorization: token ?? '', host: new URL(cfg.appSyncUrl).host };
      },
    }),
  );

  const splitLink = split(
    ({ query }) => {
      const def = getMainDefinition(query);
      return def.kind === 'OperationDefinition' && def.operation === 'subscription';
    },
    wsLink,
    authLink.concat(httpLink),
  );

  return new ApolloClient({
    link: splitLink,
    cache: new InMemoryCache(),
  });
}
